import { Typography } from "@material-ui/core"
import LinearProgress from "@material-ui/core/LinearProgress"
import { withStyles } from "@material-ui/core/styles"
import { _moveEventSponsors } from "actions/event"
import { getItems, moveItems } from "actions/items"
import classnames from "classnames"
import Item from "components/Item"
import Sponsor from "components/Sponsor"
import { subscribe, unsubscribe } from "pubsub-js"
import React, { Fragment, PureComponent } from "react"
import { HotKeys } from "react-hotkeys"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "recompose"
import { ADMIN_EVENT } from "types/pubsub"
import styles from "./styles"

const hotkeys = {
  pauseUnpauseTimer: "p"
}

let handleRaffleSub
let handleVoteSub
let reloadSub
class ItemRotator extends PureComponent {
  componentDidMount() {
    this.loadData().then(res => {
      this.setState({
        gettingItems: false
      })
      this.start()
      handleRaffleSub = subscribe(
        `${ADMIN_EVENT}::drawRaffle`,
        this.handleRaffleWinner
      )
      handleVoteSub = subscribe(
        `${ADMIN_EVENT}::fixedPurchase`,
        this.handleVote
      )
    })
    reloadSub = subscribe("GLOBAL::RELOADDATA", this.loadData)
    console.log(this.props.sponsors)
  }
  componentWillUnmount() {
    unsubscribe(handleRaffleSub)
    unsubscribe(handleVoteSub)
    unsubscribe(reloadSub)
    clearInterval(this.interval)
  }
  state = {
    iteration: 1,
    gettingItems: true,
    cardsHidden: false,
    showingRaffleWinner: false,
    raffleWinner: {
      name: "Jordan Riser",
      item: "Great Barrier Reef Snorkeling Adventure Package"
    }
  }
  interval
  loadData = () => {
    return this.props.dispatch(getItems(this.props.match.params.event_url))
  }
  start = () => {
    this.interval = setInterval(() => {
      this.setState({
        cardsHidden: true
      })
      setTimeout(() => {
        this.nextPage()
      }, 300)
    }, this.props.data.settings.timing * 1000)
  }


  handleRaffleWinner = (msg, data) => {
    const item = this.props.items.find(item => item.item_id === data.item_id)
    if (item) {
      this.setState({
        showingRaffleWinner: true,
        raffleWinner: {
          name: data.full_name,
          item: item.name
        }
      })
    }
    clearInterval(this.interval)
    setTimeout(() => {
      this.setState({
        showingRaffleWinner: false
      })
      this.start()
    }, 30000)
  }

  handleVote = (msg, data) => {
    const item = this.props.items.find(item => item.item_id === data.item_id)
    item.item_sales = data.item_sales
  }


  nextPage = () => {
    if (this.props.data.settings.include_sponsors && this.props.sponsors) {
      this.setState({
        iteration: this.state.iteration + 1
      })
    }
    setTimeout(() => {
      if (this.state.iteration % 3 === 0) {
        this.props.dispatch(_moveEventSponsors())
      } else {
        this.props.dispatch(moveItems())
      }
      setTimeout(() => {
        this.setState({
          cardsHidden: false
        })
      }, 50)
    }, 50)
  }

  pauseUnpauseTimer = () => {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    } else {
      this.start()
    }
  }
 
  render() {
    const { classes } = this.props
    const hotkeysHandlers = {
      pauseUnpauseTimer: this.pauseUnpauseTimer
    }
    return (
      <HotKeys keyMap={hotkeys} handlers={hotkeysHandlers}>
        <div className={classes.container}>
          {this.state.gettingItems && (
            <LinearProgress
              classes={{
                colorPrimary: classes.linearColorPrimary,
                barColorPrimary: classes.linearBarColorPrimary
              }}
            />
          )}
          {!this.state.gettingItems && (
            <Fragment>
              <div
                className={classnames(classes.items, {
                  [classes.itemsShow]: this.state.showingRaffleWinner === false
                })}
              >
                {this.state.iteration % 3 !== 0 &&
                  this.props.items
                    .slice(0, 5)
                    .map(item => (
                      <Item
                        key={item.item_id}
                        item={item}
                        hidden={this.state.cardsHidden}
                        showBidderInfo={
                          this.props.data.settings.show_bidder_info
                        }
                      />
                    ))}
                {this.state.iteration % 3 === 0 &&
                  this.props.sponsors
                    .slice(0, 3)
                    .map(sponsor => (
                      <Sponsor
                        key={sponsor.sponsor_id}
                        sponsor={sponsor}
                        hidden={this.state.cardsHidden}
                      />
                    ))}
              </div>
              <div
                className={classnames(classes.raffleWinner, {
                  [classes.raffleWinnerShow]:
                    this.state.showingRaffleWinner === true
                })}
              >
                <div className={classes.raffleWinnerNameArea}>
                  <Typography className={classes.raffleWinnerName}>
                    {this.state.raffleWinner.name}
                  </Typography>
                  <Typography className={classes.raffleWinnerItem}>
                    {this.state.raffleWinner.item}
                  </Typography>
                </div>
                <Typography className={classes.winnerText}>Winner!</Typography>
              </div>
            </Fragment>
          )}
          {!this.state.showingRaffleWinner && (
            <div
              className={classes.timer}
              style={{
                width: "100%",
                animationDuration: `${this.props.data.settings.timing}s`
              }}
            />
          )}
        </div>
      </HotKeys>
    )
  }
}

const mapStateToProps = (state, props) => ({
  items: state.items.items.filter(
    item => props.data.params.indexOf(item.item_id) > -1
  ),
  sponsors: state.event.event.sponsors
})

export default compose(
  withRouter,
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(ItemRotator)



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/ItemRotator/index.jsx